module.exports = __webpack_public_path__ + "static/media/ChatbotLogo.e1307c5b.svg";